export enum Documents {
    GTC = "GTC.pdf",
    PPC = "PPC.pdf",
    WARRANTY = "warranty_GTC.pdf",
    RETURNS = "returns_GTC.pdf",
    PRIVACY = "privacy_GTC.pdf"
}